document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#euphoria-theme-form");
  const button = document.querySelector("#euphoria-generate-btn");
  const preview = document.querySelector("#euphoria-theme-preview");
  const resultImage = document.querySelector("#euphoria-theme-result");

  if (!form || !button) return;

  button.addEventListener("click", async (e) => {
    e.preventDefault();

    const primaryColor = form.querySelector("[name='primaryColor']").value;
    const secondaryColor = form.querySelector("[name='secondaryColor']").value;
    const mainTheme = form.querySelector("[name='mainTheme']").value;
    const topTheme = form.querySelector("[name='topTheme']").value;
    const drawingStyle = form.querySelector("[name='drawingStyle']").value;
    const babyName = form.querySelector("[name='babyName']").value;
    const tagline = form.querySelector("[name='tagline']").value;

    button.innerHTML = "⏳ جاري التوليد...";
    button.disabled = true;

    try {
      const response = await fetch("https://node-repl-euphoriosocial.replit.app/api/generate-theme", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          primaryColor,
          secondaryColor,
          mainTheme,
          topTheme,
          drawingStyle,
          babyName,
          tagline
        })
      });

      if (!response.ok) {
        throw new Error("API Error");
      }

      const data = await response.json();
      resultImage.src = data.imageUrl;
      resultImage.style.display = "block";
    } catch (err) {
      console.error(err);
      alert("❌ خطأ: لم يتم الاتصال بالسيرفر. تأكد أن Replit يعمل.");
    } finally {
      button.disabled = false;
      button.innerHTML = "توليد الثيم";
    }
  });
});
